module.exports = __webpack_public_path__ + "assets/Erkältung.8321a07d.png";